import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl, ValidatorFn } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Material } from '@classes/material';
import { MaterialService } from 'app/core/services/material.service';
import { MaterialDetailComponent } from 'app/modules/repository/components/material-detail/material-detail.component';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-material-list',
  templateUrl: './material-list.component.html',
  styleUrls: ['./material-list.component.scss']
})
export class MaterialListComponent implements OnInit {

  @Input() set control(ctr: FormControl | null) {
    if (ctr) {
      this.myControl = ctr;
      this._initFilteredMaterials();
    }
  }
  @Input() placeHolder: string;
  @Input() displayAddButton: boolean = false;

  myControl!: FormControl;

  materials: Material[] = [];
  filteredMaterials: Observable<Material[]> | undefined;

  constructor(
    public materialService: MaterialService,
    public dialog: MatDialog
  ) {
    this._initList();
  }

  ngOnInit() {
    this._refreshList();
  }

  private _initList() {
    this.materialService.materials.subscribe(materials => {
      this.materials = materials
        .sort((a, b) =>
          (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0));
      this._initFilteredMaterials();
    }, error => {
      console.error(error);
    });
  }

  private _refreshList(){
    this.materialService.getMaterials(true).subscribe();
  }

  private _initFilteredMaterials(): void {
    if (this.myControl) {
      this.filteredMaterials = this.myControl.valueChanges
        .pipe(
          startWith(''),
          map(value => {
            if (typeof value === 'string') {
              return this._filter(value);
            }
            return []
          })
        );
    }
  }

  private _filter(value: string): Material[] {
    const filterValue = value.toLowerCase();
    return this.materials.filter(option =>
      (option.name || '').toLowerCase().includes(filterValue));
  }

  displayFn(material?: Material): string {
    return material ? (material.name || '') : '';
  }

  createMaterial() {
    const data = null;
    const dialogRef = this.dialog.open(MaterialDetailComponent, {
      data,
      hasBackdrop: true
    });
    dialogRef.afterClosed().subscribe(value => {
      if (value && value.success) {
        this._refreshList();
        this.myControl.setValue(value.data);
      }
    });
  }

}
